export default __webpack_public_path__ + "static/media/portfolio-67.20c03abc.jpg";